import React from "react";
import { FormattedMessage } from "react-intl";
import { formatDecimal } from "../../helpers/itemCalculations";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleRight, faTag } from "@fortawesome/free-solid-svg-icons";
import PaymentInProgressBanner from "../paymentInProgressBanner";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../state/store";
import { loaderOperations } from "../../state/features/loader";

interface IOrderDetailsFooterProps {
  cartDetails: any;
  amountToReachMinOrderValue: any;
  disableCheckoutButton: any;
  onCheckoutClick: any;
}
const OrderDetailsFooter = ({
  cartDetails,
  amountToReachMinOrderValue,
  disableCheckoutButton,
  onCheckoutClick,
}: IOrderDetailsFooterProps) => {
  const { currency } = useSelector((state: RootState) => state.company);
  const { recentOrder, discount } = useSelector((state: RootState) => state);
  const { redeemedPoints = 0 } = useSelector((state: RootState) => state.loyalty);
  const { is_tax_inclusive: isMenuTaxInclusive } = useSelector(
    (state: RootState) => state.menu
  );
  const dispatch = useDispatch();

  return (
    <div className='charges-breakdown'>
      <div className='charge'>
        <p>
          <FormattedMessage id='global.subtotal' defaultMessage='Subtotal' />
        </p>
        <p>
          {currency} {formatDecimal(cartDetails.subTotal)}
        </p>
      </div>
      {cartDetails.surchargeBreakDown.map((surcharge: any, index: any) => {
        return (
          <div className='charge' key={index}>
            <p className='label'>{surcharge.name}</p>
            <p className='value'>
              {currency} {formatDecimal(surcharge.amount)}
            </p>
          </div>
        );
      })}
      {cartDetails.orderPromotionDiscount > 0 ? (
        <div className='charge promotion'>
          <p className='label'>
            <FontAwesomeIcon icon={faTag} /> {cartDetails.appliedPromotionName}
          </p>
          <p className='value'>
            - {currency} {formatDecimal(cartDetails.orderPromotionDiscount)}
          </p>
        </div>
      ) : null}
      {discount ? (
        <div className='charge'>
          <p className='label'>{discount.discount_name}</p>
          <p className='value'>
            - {currency} {formatDecimal(discount.discountedAmount)}
          </p>
        </div>
      ) : null}
      {redeemedPoints ? (
        <div className='charge'>
          <p className='label'>
            <FormattedMessage id='global.loyalty' defaultMessage='Loyalty' />
          </p>
          <p className='value'>
            - {currency} {formatDecimal(redeemedPoints)}
          </p>
        </div>
      ) : null}
      {!isMenuTaxInclusive && cartDetails.taxTotal > 0 ? (
        <>
          {cartDetails.taxBreakdown && cartDetails.taxBreakdown.length > 0 ? (
            cartDetails.taxBreakdown.map((tax: any) => {
              return (
                <div className='charge' key={tax.id}>
                  <p className='label'>{`${tax.name} (${tax.rate}%)`}</p>
                  <p className='value'>
                    {currency} {formatDecimal(tax.amount)}
                  </p>
                </div>
              );
            })
          ) : (
            <div className='charge'>
              <p>
                <FormattedMessage id='global.tax' defaultMessage='Tax' />
              </p>
              <p>
                {currency} {formatDecimal(cartDetails.taxTotal)}
              </p>
            </div>
          )}
        </>
      ) : null}
      <div className='charge strong'>
        <p>
          <FormattedMessage id='global.total' defaultMessage='Total' />
        </p>
        <p>
          {currency} {formatDecimal(cartDetails.total)}
        </p>
      </div>
      {amountToReachMinOrderValue ? (
        <div className='minimumAmountNotice'>
          <FormattedMessage
            id='checkout.add_more_to_checkout'
            defaultMessage='Add {currency} {amount} more to Checkout'
            values={{
              currency,
              amount: formatDecimal(amountToReachMinOrderValue),
            }}
          />
        </div>
      ) : null}

      {recentOrder ? (
        <div className='in-progress-banner-wrapper'>
          <PaymentInProgressBanner />
        </div>
      ) : null}

      <div className='d-flex'>
        <Link
          onClick={() => dispatch(loaderOperations.showLoader())}
          to='/m'
          className={"button btn btn-outline-primary w-100 mr-3"}
        >
          <FormattedMessage
            id='cart.add_more_items'
            defaultMessage='Add more items'
          />
        </Link>
        <button
          disabled={disableCheckoutButton}
          onClick={(e) => onCheckoutClick(e)}
          className={
            disableCheckoutButton
              ? "button btn btn-secondary disabled w-100"
              : "button btn btn-primary w-100"
          }
        >
          <FormattedMessage id='global.checkout' defaultMessage='Checkout' />
          <span className='ml-3'>
            <FontAwesomeIcon icon={faChevronCircleRight} />
          </span>
        </button>
      </div>
    </div>
  );
};

export default OrderDetailsFooter;
